export const getCartItem = (cartItemId, cartItemList) => {
  return cartItemList.find(item => item.id === parseInt(cartItemId));
};
